import React from 'react'
import { DispatchStorePopover } from './DispatchStorePopover'
import { isOrderRequestV1 } from '@components/OrderDispatch/util'

export const OrderStores = ({ order, setOrderHistoryStoreId }) => {
  if (!order.drops && order.type !== 'Order Request (Requested)') return null

  if (isOrderRequestV1(order)) {
    const destination = {
      location_name: order.site_number,
      store_name: order.site_name,
      city: order.site_city,
      state: order.site_state,
      store_id: order.site_id,
      address: order.site_address,
      phone: order.site_phone,
    }

    return (
      <div>
        <DispatchStorePopover setOrderHistoryStoreId={setOrderHistoryStoreId} destinations={[destination]} />,
        <span className='ml-1'>{destination.city}</span>
      </div>
    )
  }

  return (
    <div>
      {order.drops.map((d, i) => {
        return (
          <div key={i}>
            <DispatchStorePopover setOrderHistoryStoreId={setOrderHistoryStoreId} destinations={[d]} />,
            <span className='ml-1'>{d.city}</span>
          </div>
        )
      })}
    </div>
  )
}
